import React, { PureComponent } from 'react';
import { PlateChassiStyles } from './plateChassiStyles';
import { Link } from 'react-router-dom';
import NoData from './NoData';
import ValuesOnly from './ValuesOnly';
import PricingLayout from './PricingLayout';

const message: { [key: string]: string } = {
  '1': '*O preço do referido Trator não leva em consideração as condições dos pneus, total de horas trabalhadas, tipos de equipamentos adicionais, condições de pintura e lataria, histórico de acidente/incidente, histórico de manutenção e comissão de vendas.',
  '2': '*O preço da aeronave está sujeita a variação cambial do Dólar, aos aviônicos e equipamentos adicionais, horas disponíveis ou horas totais de voo, a Revisão de 12 anos, condições do interior e exterior, histórico de acidente/incidente, histórico de manutenção, documentação da Aeronave e comissão de vendas.',
  '3': '*O preço do referido implemento é sem pneus, não leva em consideração os tipos de acessórios adicionais, tipo de suspensão, condições de pintura e lataria, histórico de acidente/incidente, histórico de manutenção e comissão de vendas.',
  '4': '*Preço da referida carroceria sobre chassi , não leva em consideração os tipos de acessórios adicionais,  condições de pintura e lataria, histórico de acidente/incidente, histórico de manutenção e comissão de vendas.”',
  '5': '',
  '6': '*O preço do referido implemento é sem pneus, não leva em consideração os tipos de acessórios adicionais, tipo de suspensão, condições de pintura e lataria, histórico de acidente/incidente, histórico de manutenção e comissão de vendas.',
};

export default class InfoPrice2 extends PureComponent<any> {
  render() {
    const { data, reference } = this.props;
    const hash = data?.content?.hash ?? '-';
    const pricing = (data?.content as any).pricing;
    const substitutes = data?.content?.values?.[0]?.substitutes ?? [];
    const values = data?.content?.values ?? [];
    const month = values[0]?.month_reference ?? '-';
    const yearReference = values[0]?.year_reference ?? '-';
    if (!values.length && !pricing) return <NoData />;


    const firstValue = values[0];
    const mainType = firstValue?.type;
    return (
      <PlateChassiStyles id="report" ref={reference} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '2rem' }}>
        <div id="report-logo">
          <Link to="https://tabelasomos.com.br">
            <img src={require('../../images/horizontalLogo.png')} width={270} alt="Logo" />
          </Link>
        </div>

        <strong id="info-message-and-hash" className="hash text-xl wrap-anywhere">
          Hash de autenticidade: {hash}
        </strong>

        <table id="report-body-card">
          <tbody>
            {!pricing && <ValuesOnly values={values} />}
            {pricing && <PricingLayout pricing={pricing} values={values} />}
            {/* <tr>
              <td className="no-border" style={{ backgroundColor: '#a3e5ff' }}>
                MÊS/ANO DE REFERÊNCIA
              </td>
              <td style={{ backgroundColor: '#a3e5ff' }}>
                {values[values.length - 1].month_reference && values[values.length - 1].year_reference
                  ? `${values[values.length - 1].month_reference}/${values[values.length - 1].year_reference}`
                  : '-'}
              </td>
            </tr> */}

            {pricing &&
              <>
                <tr style={{ backgroundColor: '#a3e5ff' }}>
                  <td className="no-border">MÊS/ANO DE REFERÊNCIA</td>
                  <td>
                    {month === '-' || yearReference === '-' ? '-' : `${month}/${yearReference}`}
                  </td>
                </tr>
                <tr>
                  <td className="no-border" style={{ backgroundColor: (!!pricing || values?.length > 1) ? '#a3e5ff' : '' }}>
                    DATA DA CONSULTA
                  </td>
                  <td style={{ backgroundColor: (!!pricing || values?.length > 1) ? '#a3e5ff' : '' }}>{values[values.length - 1]?.date_time ?? '-'}</td>
                </tr>
              </>
            }
            {!pricing && values[0].value != null && values.length <= 1 && (
              <tr className='price'>
                <td className="no-border">PREÇO MÉDIO</td>
                <td>
                  {mainType === '5' ? `R$ ${Number(values[0].value).toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}` : `R$ ${Number(values[0].value).toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}*`}
                </td>
              </tr>
            )}
            {!pricing && (values[0].current_month_value != null || values[0].initial_value != null) && values.length <= 1 && (
              <>
                {values[0].em_producao != null &&
                  <tr>
                    <td className="no-border">EM PRODUÇÃO?</td>
                    <td>
                      {values[0].em_producao}
                    </td>
                  </tr>
                }
                {values[0].current_month_value != null &&
                  <tr className='price'>
                    <td className="no-border">VALOR MÊS ATUAL</td>
                    <td>
                      R$ {Number(values[0].current_month_value).toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}*
                    </td>
                  </tr>

                }
                {values[0].initial_value != null &&
                  <tr className='price'>
                    <td className="no-border">VALOR INICIAL</td>
                    <td>
                      R$ {Number(values[0].initial_value).toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}*
                    </td>
                  </tr>
                }
              </>
            )}
            {substitutes.length > 0 &&
              <>
                {substitutes.map((item: any, index: number) => (
                  <React.Fragment key={index}>
                    <tr>
                      <td className="price" style={{ backgroundColor: '#006991', color: 'white', textAlign: 'center' }} colSpan={2}>
                        SUBSTITUIÇÃO {item.index}
                      </td>
                    </tr>
                    <tr style={{ backgroundColor: '#c9f0ff' }}>
                      <td className="no-border">FABRICANTE</td>
                      <td>{item.mounter ?? '-'}</td>
                    </tr>
                    <tr >
                      <td className="no-border">MODELO</td>
                      <td>{item.model ?? '-'}</td>
                    </tr>

                    <tr key={index}>
                      <td className="no-border">VALOR</td>
                      <td>
                        R$ {Number(item.current_value).toLocaleString('pt-BR', {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        })}*
                      </td>
                    </tr>
                    <tr key={index}>
                      <td>VARIAÇÃO EM PERCENTUAL</td>
                      <td style={{ color: item.variation_percent < 0 ? 'red' : 'green' }}>
                        {item.variation_percent}%
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
              </>
            }
          </tbody>
        </table>

        <i id="info-message-and-hash" style={window.innerWidth < 600 ? { width: '95vw', textAlign: 'center' } : { width: '50vw', textAlign: 'center' }}>
          {message[mainType]}
        </i>

        <p id="report-link-site">
          <Link to="https://tabelasomos.com.br">
            www.<strong>TABELASOMOS</strong>.com.br
          </Link>
        </p>
      </PlateChassiStyles>
    );
  }
}
